import WarningMessage from "../../../components/WarningMessage";
import AccessCode from "../../../components/AccessCode";
import TicketOrder from "./TicketOrder";
import ActionBar from "../../../components/ActionBar";
import ActionButton from "../../../components/ActionButton";
import OrderTotal from "../../../components/OrderTotal";
import { css } from "emotion";

const headingCustomStyling = {
  borderBottom: "1px solid #dedede",
  paddingBottom: 8,
  marginBottom: 0
};

const nextStageButton = css({ height: "40px !important", minWidth: 150 });

const TicketSelectionComponent = ({
  event,
  ticketSelection,
  addTicketPrice,
  addTicketQuantity,
  requestOrder,
  orderSummary,
  order,
  updateDonationAmount,
  showCustomDonationField,
  openModal
}) => {
  if (ticketSelection.ticketsRequest.loading) {
    return <div class="loading loading-lg" />;
  }
  if (!ticketSelection.ticketsRequest.loaded) {
    return null;
  }
  const eventSoldOut =
    event.data && event.data.soldOut ? event.data.soldOut : false;

  const validTickets = ticketSelection.tickets.filter(ticket => {
    if (ticket.hidden && !ticket.accessGranted) {
      return false;
    }
    return true;
  });
  const hasTickets = validTickets.length ? true : false;

  const ticketsOnSale = !hasTickets ? false : true;
  const totalTickets = ticketSelection.tickets.reduce(
    (sum, { quantity }) => sum + quantity,
    0
  );
  const ticketsRemainingDisplay = event.data.settings.ticketsRemainingDisplay;
  const clientDonation = ticketSelection.clientDonation;
  const showSeatingMapOverview =
    event.data.seatingMaps &&
    event.data.seatingMaps.length > 0 &&
    event.data.seatingMaps.reduce((show, seatingMap) => {
      return show || seatingMap.public;
    }, false);

  if (!ticketsOnSale) {
    return (
      <div>
        <WarningMessage title="There are no publicly available tickets" />
        <AccessCode />
      </div>
    );
  }
  return (
    <div>
      <h2 style={headingCustomStyling}>Choose your tickets</h2>
      {showSeatingMapOverview ? (
        <a style={{ cursor: "pointer" }} onclick={openModal}>
          Preview Seating Map
        </a>
      ) : null}
      <TicketOrder
        ticketGroups={event.data.ticketGroups}
        tickets={ticketSelection.tickets}
        addTicketQuantity={addTicketQuantity}
        addTicketPrice={addTicketPrice}
        ticketSelection={ticketSelection}
        updateDonationAmount={updateDonationAmount}
        ticketsRemainingDisplay={ticketsRemainingDisplay}
        eventSoldOut={eventSoldOut}
        showCustomDonationField={showCustomDonationField}
      />
      <AccessCode />
      <ActionBar>
        <OrderTotal orderSummary={orderSummary} />
        <ActionButton
          disabled={
            orderSummary.loading ||
            order.orderRequest.loading ||
            ((!totalTickets && !clientDonation) || clientDonation < 0)
          }
          onClick={requestOrder}
          loading={order.orderRequest.loading || orderSummary.loading}
          dataCY="EnterDetails"
          classNames={nextStageButton}
        >
          Enter Details
        </ActionButton>
      </ActionBar>
    </div>
  );
};
export default TicketSelectionComponent;



// WEBPACK FOOTER //
// ./routes/tickets/components/TicketSelectionComponent.js